/**
 * @generated SignedSource<<05d22fcbd8477f3b220ccbc8aa65dc68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSettings_note$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "SeriesSettings_note";
};
export type SeriesSettings_note$key = {
  readonly " $data"?: SeriesSettings_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSettings_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSettings_note",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "8c4b69b4f8e88234b8288aefcc005139";

export default node;
